import React, { Component } from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { colors } from "../../styles/Colors";

const HtmlToReact = require("html-to-react");
const HtmlToReactParser = require("html-to-react").Parser;

class HTML extends Component {
    render() {
        const { html, style, onLinkClick } = this.props;

        const htmlToReactParser = new HtmlToReactParser();
        const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
        const reactElement = htmlToReactParser.parseWithInstructions(html, () => true, [
            {
                replaceChildren: false,
                shouldProcessNode: node => node.name === "a" || node.name === "p",
                processNode: (node, children, idx) => {
                    if (node.name === "a") {
                        const { href, ...props } = node.attribs;
                        const isExternal = !/^\/[\w-]/.test(href);
                        return (
                            // eslint-disable-next-line react/jsx-no-target-blank
                            <a
                                href={href}
                                onClick={() => {
                                    if (onLinkClick) onLinkClick(href);
                                }}
                                key={idx}
                                rel={isExternal ? "noopener" : undefined}
                                target={isExternal ? "_blank" : undefined}
                                {...props}
                                style={{ color: colors.primary, textDecoration: "underline" }}
                            >
                                {children}
                            </a>
                        );
                    } else if (node.name === "p") {
                        return (
                            <p
                                key={idx}
                                {...node.attribs}
                                style={{ marginBottom: 16, marginTop: 0 }}
                            >
                                {children}
                            </p>
                        );
                    }
                },
            },

            {
                shouldProcessNode: () => true,
                processNode: processNodeDefinitions.processDefaultNode,
            },
        ]);

        return <div css={style}>{reactElement}</div>;
    }
}

export default HTML;
